import { useContext } from 'react';
import { HeaderActionsColumn } from '../columns';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import { ActionInlineEditor } from 'domains/designers/RuleDesigner/actions/ActionInlineEditor';
import { ActionModel } from 'domains/designers/RuleDesigner/models/ActionModel';
import { Cell } from '.';
import { ValidationIcon } from 'domains/designers/common';
import { CellIconButton } from '../components/CellIconButton';
import { RuleExecutionResult } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Events';
import { getResultBackgroundColor } from '../TruthTableUtils';
import { getValueIssues } from 'domains/designers/RuleDesigner/RuleActionUtils';

export interface IHeaderActionValueCellProps {
  sessionId: string;
  actionModel: ActionModel;
  executionResult: RuleExecutionResult | null;
}

export function HeaderActionValueCell({ sessionId, actionModel, executionResult }: IHeaderActionValueCellProps) {
  const { isDebug } = useContext(RuleDesignerContext);
  const handler = actionModel.getHandler();
  const valueIssues = getValueIssues(actionModel.getValidationIssues());

  return (
    <HeaderActionsColumn
      style={{ backgroundColor: getResultBackgroundColor(executionResult) }}
      data-column-name={actionModel.ActionName}
    >
      <Cell className="tt-header-action-value-cell">
        <ValidationIcon validationIssues={valueIssues} />
        <ActionInlineEditor
          className="tt-header-action-value-cell__editor-wrapper"
          sessionId={sessionId}
          actionModel={actionModel}
          handler={handler}
          isDebug={isDebug}
        />
        {!isDebug && actionModel.canEdit() && (
          <CellIconButton
            iconClassName="tt-header-action-value-cell__edit-icon"
            onClick={e => {
              handler.edit(e.target as HTMLElement);
            }}
          />
        )}
      </Cell>
    </HeaderActionsColumn>
  );
}
